import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

import { request } from "@/Api";
import { Heading, SubHeading } from "@/auth/StyledComponents";
import { PageTitle } from "@/common/CommonComponents";

export default function PaymentSuccess() {
    const { purchaseId } = useParams();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [purchase, setPurchase] = useState(null);

    useEffect(() => {
        if (purchaseId) {
            request
                .get(`/payments/purchase/${purchaseId}`)
                .then((response) => {
                    setPurchase(response.data);
                })
                .catch(() => {
                    setError("Failed to load purchase.");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, []);

    return (
        <>
            <Helmet>
                <PageTitle title="Payment Success" />
            </Helmet>

            <Grid
                container
                direction="column"
                spacing={2}
                sx={{ marginTop: "48px", textAlign: "center" }}
            >
                {loading ? (
                    <CircularProgress />
                ) : error ? (
                    <Grid item>
                        <SubHeading>{error}</SubHeading>
                    </Grid>
                ) : (
                    <>
                        <Grid item>
                            <Heading>Purchase Complete</Heading>
                        </Grid>
                        <Grid item>
                            <SubHeading>
                                Please enjoy your AI responsibly.
                            </SubHeading>
                        </Grid>
                        <Grid item>
                            <p>{purchase.description}</p>
                            <p>{purchase.payment_method}</p>
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
}
